import "./InventoryListTableComponent.scss";
import {ITableColumn} from "../../../shared/models/table.model";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";
import {CommonService} from "../../../shared/services";
import React, {useCallback} from "react";
import SwitchComponent from "../../../shared/components/core/switch/switchComponent";
import {Link} from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {APIConfig, ImageConfig} from "../../../constants";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {IProduct} from "../../../shared/models/inventory.model";
import commonService from "../../../shared/services/common.service";

interface InventoryListTableComponentProps {
    filterData: any;
}

const MODULE_NAME = "InventoryList"


const InventoryListTableComponent = (props: InventoryListTableComponentProps) => {

    const {filterData} = props;
    // const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const columns: ITableColumn[] = [
        {
            id: 'name',
            label: 'Product Name',
            isDefaultColumn: true,
            fixed: "left",
            width: "250",
            content: (item: IProduct) => (
                <>
                    {
                        (item?.name).length > 23 ?
                            <TooltipComponent
                                tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.name)}
                                placement={"top"}
                                arrow={true}
                            >
                                <>
                                    <div className={"ellipses-for-table-data"}>
                                        {CommonService.capitalizeFirstLetterOfEachWord(item?.name)}
                                    </div>
                                </>
                            </TooltipComponent> :
                            <>
                                {CommonService.capitalizeFirstLetterOfEachWord(item?.name)}
                            </>
                    }
                </>
            )
        },
        {
            id: 'panelName',
            label: 'Panel Name',
            isDefaultColumn: true,
            width: "200",
            content: (item: IProduct) => (
                <>
                    {
                        (item?.name).length > 13 ?
                            <TooltipComponent
                                tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.panelDetails?.name)}
                                placement={"top"}
                                arrow={true}
                            >
                                <>
                                    <div className={"ellipses-for-table-data"}>
                                        {CommonService.capitalizeFirstLetterOfEachWord(item?.panelDetails?.name)}
                                    </div>
                                </>
                            </TooltipComponent> :
                            <>
                                {CommonService.capitalizeFirstLetterOfEachWord(item?.panelDetails?.name)}
                            </>
                    }
                </>
            )
        },
        {
            id: 'productCode',
            label: 'Product Code',
            isDefaultColumn: false,
            align: 'center',
            content: (item: IProduct) => (
                <>
                    {
                        (item?.productCode).length > 13 ?
                            <TooltipComponent
                                tooltip={CommonService.capitalizeFirstLetterOfEachWord(item?.productCode)}
                                placement={"top"}
                                arrow={true}
                            >
                                <>
                                    <div className={"ellipses-for-table-data"}>

                                        {CommonService.capitalizeFirstLetterOfEachWord(item?.productCode)}
                                    </div>
                                </>
                            </TooltipComponent> :
                            <>
                                {CommonService.capitalizeFirstLetterOfEachWord(item?.productCode)}
                            </>
                    }
                </>
            )
        },
        {id: 'quantity', label: 'Available Kits', isDefaultColumn: true,align: 'center'},
        {id: 'alertLevelStock', label: 'Alert Level Quantity', isDefaultColumn: false,align: 'center'},
        {
            id: 'updatedAt', label: 'Last Updated', isDefaultColumn: false, align: 'center',
            content: (item: IProduct) => (
                <>
                    {
                        item?.updatedAt ?
                            <>
                                {commonService.formatDate(item?.updatedAt)}
                                &nbsp;|&nbsp;
                                {commonService.formatTime(item?.updatedAt)} <br/>
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'updatedBy', label: 'Updated By', isDefaultColumn: false, align: 'center',
            content: (item: IProduct) => (
                <>
                    {item?.lastUpdatedByDetails ? <>{item?.lastUpdatedByDetails?.firstName} {item?.lastUpdatedByDetails?.lastName}</> : '-'}
                </>
            )
        },

        {id: 'price', label: 'Retail Price', isDefaultColumn: false,align: 'center'},
        {
            id: 'isActive',
            label:
            // commonService.checkAccess('Facility',
            // 'facilityToggle', currentUser?.userAccessModules) ?
                'Active/Inactive',
// : "",
            align: 'center',
            width:
            // commonService.checkAccess('Facility',
            //     'facilityToggle', currentUser?.userAccessModules) ?
                "150",
            // : "10"
            isDefaultColumn: true,
            content: (item: IProduct, index: any) => (
                <React.Fragment>
                    {/*{*/}
                    {/*    commonService.checkAccess('Facility',*/}
                    {/*        'facilityToggle', currentUser?.userAccessModules) ?*/}
                    <SwitchComponent
                        size={"small"}
                        checked={item?.isActive}
                        onUpdate={() => handleProductToggle(item)}/>
                    <></>
                    {/*}*/}
                </React.Fragment>
            )
        },

        {
            id: 'actions',
            label: '',
            fixed: "right",
            isDefaultColumn: true,
            hideInColumnPreferences: true,
            align: 'center',
            width: "100",
            content: (item: IProduct, index: any) => (
                <React.Fragment>
                    <div className="table-actions" id={`view_product_` + index}>
                        <Link to={CommonService._routeConfig.InventoryDetailsRoute(item?.id)}>
                            <div className="table-action">
                                <ChevronRightIcon/>
                            </div>
                        </Link>
                    </div>
                </React.Fragment>
            )
        },
    ];

    const onToggleProduct = useCallback((item: any) => {
        CommonService._inventory.toggleProductStatus(item.id, {})
            .then((response: IAPIResponseType<any>) => {
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: MODULE_NAME
                });
                CommonService._alert.showToast(response?.message || `Product has been  ${item?.isActive ? "deactivated" : "activated"}`, "success");
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error?.error || `Error while ${item?.isActive ? "deactivating" : "activating"} the product`, "error");
            });
    }, []);

    const handleProductToggle = useCallback((item: any) => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Please confirm!',
            confirmationSubTitle: `Are you sure you want to ${item?.isActive ? "deactivate" : "activate"} this product?`,
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.ConfirmationImage}`,
            direction: "up",
            yes: {
                text: `${item?.isActive ? "Deactivate" : "Activate"}`,
                color: "primary"
            },
            no: {
                text: "Cancel",
                color: "primary"
            }
        })
            .then(() => {
                onToggleProduct(item);
            })
            .catch(() => {
            })
    }, [onToggleProduct]);

    return (
        <div className="table-list-container">
            <TableWrapperV2Component
                isPaginated={true}
                columns={columns}
                url={APIConfig.GET_INVENTORY_LIST.URL}
                method={APIConfig.GET_INVENTORY_LIST.METHOD}
                extraPayload={filterData}
                isColumnFilterVisible={true}
                moduleName={MODULE_NAME}
            />
        </div>
    );

};

export default InventoryListTableComponent;
